export const phoneMaxLength = 10;

export const activateRenewedCardConstants = {
  heading: '# Activate your renewed card',
  subHeading: '### Complete the activation process for your renewed card',
  activateCardText: `${process.env.REACT_APP_ACTIVATE_CARD_TEXT}`,
  sendOTPButtonText: 'Send OTP',
  otpModalTitle: 'Enter OTP Code',
  otpModalSubText: 'We have sent a verification code to the mobile number associated with your card',
  otpValidityText: 'The OTP is valid for 15 minutes and you have 10 attempts to enter it correctly.',
  validations: {
    activationCode: {
      required: 'Activation code is required',
      format: 'Activation code can only contain letters & numbers',
    },
    phoneNumber: {
      required: 'Mobile number is required',
      format: 'Please enter a valid Australian mobile number (e.g., 0412 345 678 or +61 412 345 678)',
    },
  },
  defaultValue: {
    activationCode: '',
    phoneNumber: '',
  },
  activationCodeSubText: `This can be located on the back of your card. It is alphanumerical and 9 digits long`,
  phoneNumberSubText: `Enter the mobile number associated with your card.`,
};